import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { DrawerComponents } from '../components/Navigation/PageLayout';
// --------------
// STATE

export interface SidebarDrawerState {
    active: DrawerComponents | null;
    groupsList: number | null;
    hasEntered: boolean;
}

const initialState: SidebarDrawerState = {
    active: 'new/Recent',
    groupsList: null,
    hasEntered: true,
};

const sidebarDrawerSlice = createSlice({
    name: 'sidebarDrawer',
    initialState,
    reducers: {
        setSidebar: (state, action: PayloadAction<Partial<SidebarDrawerState>>) => {
            Object.assign(state, action.payload);
        },
        setHasEntered: (state, action: PayloadAction<boolean>) => {
            state.hasEntered = action.payload;
        },
    },
});

export const { setSidebar, setHasEntered } = sidebarDrawerSlice.actions;

export default sidebarDrawerSlice.reducer;
